<script setup lang="ts">
import type { SlugBodyItem } from '~/components/slug/body';

useSeoMeta({
  title: 'Lezecké stěny | Okgym - Fitcentrum | Pardubický Kraj',
  description:
    'Fitness, Gym, Solarium, Box - Lepší nabídku nenajdeš! Pro studenty zvýhodněná nabídka jen v Okgym',
});

const services: SlugBodyItem[] = [
  {
    title: 'Lezecká stěna 8m',
    description:
      '<p>Naše lezecká stěna o výšce 8 metrů nabízí desítky cest různých obtížností, které jsou nastavené jak pro začátečníky, tak pro pokročilé. Vyzkoušet si můžeš i různé náklony stěny. Stěna má navíc 2 posuvné navijáky. Nabízíme kurzy jak skupinové, tak individuální. Instruktor ti bude k dispozici dle předchozí domluvy.</p>',
    image: {
      url: '/images/steny/lezecka.webp',
      alt: 'Lezecká stěna 8m',
    },
  },
  {
    title: 'Bouldrová stěna',
    description:
      '<p>Bouldrová stěna s převisy a molitanovým dopadištěm je vysoká 3,8 metru. I zde si vybereš z několika desítek cest a obtížností. Součástí je také Campus board pro rozvoj síly.</p>',
    image: {
      url: '/images/steny/boulder.webp',
      alt: 'Bouldrová stěna',
    },
  },
  {
    title: 'MoonBoard',
    description:
      '<p>Vyzkoušej MoonBoard – chytrou lezeckou stěnu nové generace! Je to stěna v náklonu 25 až 40 stupňů s chyty v předem daném vzoru. Chyty jsou podsvícené a napojené na cvičební aplikaci.</p>',
    image: {
      url: '/images/steny/moon.webp',
      alt: 'MoonBoard',
    },
  },
  {
    title: 'Zázemí a služby',
    description:
      '<p><b>Půjčovna:</b> Veškeré lezecké vybavení si můžeš půjčit přímo u nás. <br><b>Bar a posezení:</b> Čeká na tebe luxusní sociální zázemí i příjemné posezení s občerstvením a nápoji, kde můžeš zhodnotit svůj progress nebo si naplánovat další projekt.<br><b>Relax:</b> Po lezení si můžeš dopřát ještě saunu či masáž.</p>',
    image: {
      url: '/images/steny/zazemi-a-sluzby.webp',
      alt: 'Bouldrová stěna',
    },
  },
];

const text = {
  title: 'Přijď překonávat své limity a vyčistit si hlavu.',
  subtitle: 'LEZECKÁ STĚNA A BOULDER',
  description:
    'Jsme malá, útulná stěna s přátelskou atmosférou. Místo, kde se tvoří komunita a příběhy. Tady vypneš hlavu od každodenního koloběhu života a můžeš se soustředit na posouvání svých limitů. Prostor, kde si užiješ zábavu s kamarády nebo příjemně strávený čas s rodinou. Lezení je úplně jiný pohyb – posílíš zejména střed těla (core), zjistíš, jakou máš vytrvalost, flexibilitu, ale i jak pracuješ s hlavou a dechem.',
} as const;
</script>

<template>
  <PageContainer no-alignment no-padding>
    <SlugHeader
      :title="text.title"
      :subtitle="text.subtitle"
      :description="text.description"
      icon="icon:climber"
      :image-header="{
        url: '/images/steny/header.webp',
        alt: 'Lezecká stěna',
      }"
      :links="[
        {
          to: '/cenik-stena.pdf',
          label: 'Ceník',
          icon: 'icon:document',
        },
        {
          to: '/cenik-stena-kurzy.pdf',
          label: 'Ceník kurzů',
          icon: 'icon:document',
        },
      ]"
    />
    <SlugBody :items="services" />
    <Feed />
    <IndexGallery />
  </PageContainer>
</template>
